// Poslat klientku sales k volání (mockup v8, obrazovka 14). Owner, manažer a CSM z detailu klientky.
import React, { useEffect, useState } from "react";
import { PhoneForwarded } from "lucide-react";
import { Modal, HlavickaOkna, Field } from "../ui.jsx";
import DatePicker from "../DatePicker.jsx";
import { toast } from "../Toast.jsx";
import { confirmDialog } from "../confirmHost.jsx";
import { salesPost, dnesIso, addDays } from "./salesApi.js";
import { Volby, Cipy, Oznameni } from "./salesUi.jsx";

const DUVODY = [
  { key: "skoncila", label: "Skončila spolupráce" }, { key: "neuzavrela", label: "Neuzavřela po zkušebním tréninku" }, { key: "pozdeji", label: "Ozvat se později" },
];
const KDY = [{ key: "hned", label: "Hned" }, { key: "mesic", label: "Za měsíc" }, { key: "3mesice", label: "Za 3 měsíce" }, { key: "rok", label: "Za rok" }, { key: "vlastni", label: "Vlastní datum" }];
function datumKdy(k) {
  const d = dnesIso();
  if (k === "mesic") return addDays(d, 30);
  if (k === "3mesice") return addDays(d, 91);
  if (k === "rok") return addDays(d, 365);
  return d;
}

const fmtIso = (iso) => { const [y, m, d] = String(iso).split("-").map(Number); return `${d}. ${m}. ${y}`; };

// 17. 10. 2026: hovor = už naplánovaný hovor sales (z karty klientky). Odesláním se přesune
// na nové datum, druhý hovor nevznikne (salesAkce.klientkaKVolani).
export default function PoslatSalesDialog({ klient, hovor = null, open, onClose }) {
  const [duvod, setDuvod] = useState("skoncila");
  const [kdy, setKdy] = useState("hned");
  const [datum, setDatum] = useState(dnesIso());
  const [pozn, setPozn] = useState("");
  const [busy, setBusy] = useState(false);
  const [chyba, setChyba] = useState("");
  useEffect(() => { if (open) { setDuvod(klient?.stav === "Ukončeno" ? "skoncila" : "pozdeji"); setKdy("hned"); setDatum(dnesIso()); setPozn(""); setChyba(""); } }, [open, klient]);
  const zmenKdy = (k) => { const v = k || "hned"; setKdy(v); if (v !== "vlastni") setDatum(datumKdy(v)); };
  const uloz = async () => {
    // 17. 10. 2026 (Láďa): druhý hovor se nenastavuje potichu, nejdřív otázka na přepsání.
    if (hovor && hovor.datum !== datum) {
      const ok = await confirmDialog({ title: "Přepsat naplánovaný hovor?", description: `Sales jí už volá ${fmtIso(hovor.datum)}. Hovor se přesune na ${fmtIso(datum)}, druhý nevznikne.`, confirmLabel: `Přepsat na ${fmtIso(datum)}`, variant: "warning" });
      if (!ok) return;
    }
    setBusy(true); setChyba("");
    try {
      await salesPost("poslat_sales", { klient_id: klient.notion_id, duvod, datum, poznamka: pozn });
      toast(hovor ? "Hovor přesunut, sales ho uvidí v Plánu v nový den." : datum > dnesIso() ? "Posláno, sales ji uvidí v Plánu v zadaný den." : "Posláno, sales ji má v Plánu na dnes.", "success");
      onClose();
    } catch (e) { setChyba(e.message); }
    finally { setBusy(false); }
  };
  if (!klient) return null;
  return (
    <Modal open={open} onClose={onClose} size="sm" plnaHlavicka
      header={<HlavickaOkna ikona={PhoneForwarded} nazev="Poslat sales k volání" popis={klient.klient || klient.klient_name} onClose={onClose} />}
      footer={<>
        <button type="button" className="btn-secondary" onClick={onClose}>Zpět</button>
        <button type="button" className="btn-primary" onClick={uloz} disabled={busy || !datum} aria-busy={busy}>{hovor ? "Přesunout hovor" : "Poslat sales"}</button>
      </>}>
      <div className="space-y-4">
        {chyba && <Oznameni ton="problem">{chyba}</Oznameni>}
        {hovor && <Oznameni ton="pozor" ikona={PhoneForwarded}><b>Sales jí už volá {fmtIso(hovor.datum)}.</b> Další hovor nevznikne, odesláním se tento přesune na nové datum.</Oznameni>}
        <div><span className="label">Proč</span><Volby moznosti={DUVODY} value={duvod} onChange={setDuvod} name="Proč" /></div>
        <div><span className="label">Kdy má sales zavolat</span><Cipy moznosti={KDY} value={kdy} onChange={zmenKdy} /></div>
        <div><span className="label">Datum</span><DatePicker value={datum} min={dnesIso()} onChange={(d) => { setDatum(d); setKdy("vlastni"); }} /></div>
        <Field label="Poznámka pro sales"><textarea className="field min-h-[70px]" value={pozn} onChange={(e) => setPozn(e.target.value)} placeholder="Např. chce začít po stěhování, nabídnout Michala" /></Field>
      </div>
    </Modal>
  );
}
